export default class Callbacks {
    constructor(events) {
        this.events = {};
        this.set(events);
    }

    set(events = {}) {
        Object.keys(events).forEach((key) => {
            this.events[key] = events[key];
        });
    }

    trigger(name, ...args) {
        var callbacks = this.events || {};

        if (
            !name ||
            !callbacks[name] ||
            typeof callbacks[name] !== 'function'
        ) {
            return undefined;
        }

        return callbacks[name].apply(callbacks.this || this, args);
    }

    isSet(key) {
        return key ? !!this.events[key] : false;
    }
}
